import {RankedTester, rankWith, uiTypeIs} from "@jsonforms/core";
import {MicrositeUiType} from "./microsite.ui.type";

export const micrositeRendererTester: RankedTester = rankWith(6, uiTypeIs(MicrositeUiType.Microsite));
